export default __webpack_public_path__ + "static/media/no_report.64196101.svg";